import request from '@/utils/request'

export function pageModule(query) {
  return request({
    url: '/system/module/page',
    method: 'get',
    params: query
  })
}

export function addModule(data) {
  return request({
    url: '/system/module/add',
    method: 'post',
    data: data
  })
}

export function editModule(data) {
  return request({
    url: '/system/module/edit',
    method: 'post',
    data: data
  })
}

export function deleteModule(data) {
  return request({
    url: '/system/module/delete',
    method: 'post',
    data: data
  })
}

export function disableModule(data) {
  return request({
    url: '/system/module/disable',
    method: 'post',
    data: data
  })
}

export function getModuleDetail(id) {
  return request({
    url: '/system/module/detail',
    method: 'get',
    params: { id }
  })
}

export function getModuleTenantList(tenantId) {
  return request({
    url: '/system/module/tenant/list',
    method: 'get',
    params: { tenantId }
  })
}

export function addModuleTenant(data) {
  return request({
    url: '/system/module/tenant/add',
    method: 'post',
    data: data
  })
}

export function getModuleMenuList(moduleId, menuId) {
  return request({
    url: '/system/module/menu/list',
    method: 'get',
    params: {
      moduleId,
      menuId: menuId || undefined
    }
  })
}

export function addModuleMenu(data) {
  return request({
    url: '/system/module/menu/add',
    method: 'post',
    data: data
  })
}

